// src/client/main.tsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { initSentry } from './lib/sentry';
import './styles/theme.css';
import './styles/reset.css';
import './styles/typography.css';
import './styles/layout.css';

try {
  initSentry();
} catch (e) {
  // Sentry init must not block app boot. If it fails, log to console
  // (which is the only mechanism available pre-render) and continue.
  console.error('Sentry init failed', e);
}

const container = document.getElementById('client-root');
if (!container) throw new Error('client-root missing from index.html');

createRoot(container).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
